import {generateDefaultModel} from '@github-ui/copilot-chat/utils/models'
import {AUTO_MODEL_ID, getAutoModel} from '@github-ui/copilot-chat-helpers/auto-model'
import {copilotFeatureFlags} from '@github-ui/copilot-feature-flags'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useSearchParams} from '@github-ui/use-navigate'
import {useEffect, useEffectEvent, useRef} from 'react'

import LoggedOutView from '../components/LoggedOutView/LoggedOutView'
import {CopilotContext} from './../contexts/CopilotContext'
import {useInitialCopilotContext} from './../hooks/useInitialCopilotContext'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface CopilotImmersiveLoggedOutProps {}

const defaultProps: Partial<CopilotImmersiveLoggedOutProps> = {}

const CopilotImmersiveLoggedOut = (props: CopilotImmersiveLoggedOutProps) => {
  const initializedProps: CopilotImmersiveLoggedOutProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  const [searchParams, setSearchParams] = useSearchParams()
  // Gate the Auto-mode lock so "Auto" doesn't leak on this public surface before launch.
  const isAutoModeLocked = copilotFeatureFlags.autoModePickerFreeEdu
  const defaultModel = isAutoModeLocked ? getAutoModel() : generateDefaultModel()
  const initialModelId = isAutoModeLocked ? AUTO_MODEL_ID : defaultModel.id
  const autoPopulated = useRef(false)

  const {copilotContextValue} = useInitialCopilotContext({defaultModel})

  // Runs once (guarded by the ref): seeds the prompt from the query string and
  // strips legacy deep-link params. An effect event reads the latest
  // searchParams/setSearchParams/context without making them reactive triggers.
  const populateFromDeepLink = useEffectEvent(() => {
    if (autoPopulated.current) return
    autoPopulated.current = true

    const queryPrompt = searchParams.get('prompt')
    if (queryPrompt) copilotContextValue.setPrompt(queryPrompt)

    // Picker is non-selectable for logged-out users; drop legacy deep-link params.
    const newSearchParams = new URLSearchParams(searchParams)
    newSearchParams.delete('prompt')
    newSearchParams.delete('model')
    setSearchParams(newSearchParams, {replace: true})
  })

  useEffect(() => {
    populateFromDeepLink()
  }, [])

  return (
    <CopilotContext value={copilotContextValue}>
      <LoggedOutView
        initialModelId={initialModelId}
        onIdeListItemClick={(_, ideName) => {
          sendEvent('click', {
            category: 'copilot_loggedOut',
            action: 'ide_option_click',
            label: 'copilot_loggedOut',
            ideName,
          })
        }}
      />
    </CopilotContext>
  )
}

export default CopilotImmersiveLoggedOut
